import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReadOnly = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	"aria-hidden": "true",
	"data-icon": "read-only",
	viewBox: "64 64 896 896",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M680.61 172.005c-2.805 0-5.402 1.037-7.376 3.01L491.84 356.414l55.67 55.67L680.61 279.017l76.157 76.154-133.104 133.066 55.602 55.603 181.398-181.396c4.05-4.043 4.05-10.606 0-14.649l-172.674-172.78c-1.974-1.973-4.573-3.01-7.379-3.01m-335.703 331.34-133.8 133.114c-1.559 1.558-2.493 3.43-2.908 5.507l-30.65 174.752a34.8 34.8 0 0 0 9.767 30.962c6.857 6.65 15.48 10.286 24.726 10.286 2.078 0 4.156-.208 6.234-.52l174.753-30.649c2.078-.415 4.051-1.351 5.506-2.91l133.799-133.116-55.621-55.62-118.489 117.775-92.363 16.313 16.207-92.468 118.489-117.777Z" }), /* @__PURE__ */ _jsx("rect", {
		width: 82.864,
		height: 1047.123,
		x: -50.031,
		y: 215.035,
		rx: 10.458,
		ry: 10.458,
		transform: "rotate(-45)"
	})]
});
export default SvgIconReadOnly;
